import { useEffect, useRef } from 'react';
import { useBaseStepperContext } from '../../contexts/BaseStepperContext';
import { Box, BoxProps } from '@mui/material';

interface ScrollToTopBoxProps extends BoxProps {
  children?: React.ReactNode;
}

const ScrollToTopBox: React.FC<ScrollToTopBoxProps> = ({
  children,
  ...rest
}) => {
  const { activeStep } = useBaseStepperContext();

  const topRef = useRef<HTMLDivElement>(null); // Create a ref

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [activeStep]);

  return (
    <Box ref={topRef} {...rest}>
      {children}
    </Box>
  );
};
export default ScrollToTopBox;
